import { render, staticRenderFns } from "./formbuilderCompletedMessage.vue?vue&type=template&id=154a28e5&scoped=true"
import script from "./formbuilderCompletedMessage.vue?vue&type=script&lang=js"
export * from "./formbuilderCompletedMessage.vue?vue&type=script&lang=js"
import style0 from "./formbuilderCompletedMessage.vue?vue&type=style&index=0&id=154a28e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a28e5",
  null
  
)

export default component.exports